<template src="./ServicesByAnalyst.html"></template>
<script>
import { getServicesByAnalyst } from '../../../services'
import { getTodayFormat, formatDateUTC } from '../../../utils/computeds'

export default {
  name: 'ServicesByAnalyst',
  data () {
    return {
      tab: 0,
      analyst: {},
      analysts: [],
      servicesByAnalyst: [],
      format: 'DD [de] MMMM, YYYY',
      sortOrder: 'asc',
      sortField: 'evaluatedName'
    }
  },
  created () {
    this.loadServicesByAnalyst()
  },
  methods: {
    async loadServicesByAnalyst () {
      try {
        this.servicesByAnalyst = await getServicesByAnalyst()
        this.analysts = this.servicesByAnalyst.map(analyst => ({
          fullName: analyst.fullName,
          quantity: analyst.processes.length
        }))
        this.analyst = this.servicesByAnalyst[0]
      } catch (error) {
        console.log('Error on get pendingToFinish =>', error)
      }
    },
    filterAnalyst (analyst) {
      this.analyst = this.servicesByAnalyst.find(service => service.fullName === analyst)
    },
    toggleSortOrder (field) {
      if (this.sortField === field) {
        this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc'
      } else {
        this.sortField = field
        this.sortOrder = 'asc'
      }
      this.sortData()
    },
    sortData () {
      this.analyst.processes.sort((a, b) => {
        const valueA = a[this.sortField]
        const valueB = b[this.sortField]

        if (typeof valueA === 'number' && typeof valueB === 'number') {
          return this.sortOrder === 'asc' ? valueA - valueB : valueB - valueA
        } else if (typeof valueA === 'string' && typeof valueB === 'string') {
          return this.sortOrder === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA)
        }

        return 0
      })
    }
  },
  computed: {
    getTodayFormat,
    formatDateUTC,
    totalPendingServices () {
      return this.servicesByAnalyst.reduce((total, analyst) => {
        return total + (analyst.processes?.length || 0)
      }, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
table.custom-table, table.custom-table tr td {
  background: #efeeee;
}
</style>
